import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  EVALUATION_LIST,
  EVALUATION_SEARCH_ASSESSMENT,
  EVALUATION_SEARCH_ASSESSMENT_PROJECT,
  EVALUATION_SEARCH_SUPERVISION_REPORT,
  EVALUATION_ADD,
  EVALUATION_DETAIL,
  EVALUATION_GET,
  EVALUATION_UPDATE,
  EVALUATION_UPLOAD_SET
} from '../../actions';
import {
  EvaluationListSuccess,
  EvaluationListError,
  EvaluationSearchAssessmentSuccess,
  EvaluationSearchAssessmentError,
  EvaluationSearchAssessmentProjectSuccess,
  EvaluationSearchAssessmentProjectError,
  EvaluationSearchSupervisionReportSuccess,
  EvaluationSearchSupervisionReportError,
  EvaluationAddSuccess,
  EvaluationAddError,
  EvaluationDetailSuccess,
  EvaluationDetailError,
  EvaluationGetSuccess,
  EvaluationGetError,
  EvaluationUpdateSuccess,
  EvaluationUpdateError,
  EvaluationUploadSetSuccess,
  EvaluationUploadSetError
} from '../../actions';
 
export function* watchEvaluationList() {
  yield takeEvery(EVALUATION_LIST, onEvaluationList);
}

export function* watchEvaluationSearchAssessment() {
  yield takeEvery(EVALUATION_SEARCH_ASSESSMENT, onEvaluationSearchAssessment);
}

export function* watchEvaluationSearchAssessmentProject() {
  yield takeEvery(EVALUATION_SEARCH_ASSESSMENT_PROJECT, onEvaluationSearchAssessmentProject);
}

export function* watchEvaluationSearchSupervisionReport() {
  yield takeEvery(EVALUATION_SEARCH_SUPERVISION_REPORT, onEvaluationSearchSupervisionReport);
}

export function* watchEvaluationAdd() {
  yield takeEvery(EVALUATION_ADD, onEvaluationAdd);
}

export function* watchEvaluationDetail() {
  yield takeEvery(EVALUATION_DETAIL, onEvaluationDetail);
}

export function* watchEvaluationGet() {
  yield takeEvery(EVALUATION_GET, onEvaluationGet);
}

export function* watchEvaluationUpdate() {
  yield takeEvery(EVALUATION_UPDATE, onEvaluationUpdate);
}

export function* watchEvaluationUpload() {
  yield takeEvery(EVALUATION_UPLOAD_SET, onEvaluationUpload);
}

const onEvaluationListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEvaluationSearchAssessmentAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationSearchAssessmentProjectAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment_project', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationSearchSupervisionReportAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/supervision_report', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEvaluationDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationGetAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation/get', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/evaluation/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onEvaluationList(data) {
  try {
    const response = yield call(onEvaluationListAsync, data.payload);
    yield put(EvaluationListSuccess(response.data));
  } catch (error) {
    yield put(EvaluationListError(error));
  }
}

function* onEvaluationSearchAssessment(data) {
  try {
    const response = yield call(onEvaluationSearchAssessmentAsync, data.payload);
    yield put(EvaluationSearchAssessmentSuccess(response.data));
  } catch (error) {
    yield put(EvaluationSearchAssessmentError(error));
  }
}

function* onEvaluationSearchAssessmentProject(data) {
  try {
    const response = yield call(onEvaluationSearchAssessmentProjectAsync, data.payload);
    yield put(EvaluationSearchAssessmentProjectSuccess(response.data));
  } catch (error) {
    yield put(EvaluationSearchAssessmentProjectError(error));
  }
}

function* onEvaluationSearchSupervisionReport(data) {
  try {
    const response = yield call(onEvaluationSearchSupervisionReportAsync, data.payload);
    yield put(EvaluationSearchSupervisionReportSuccess(response.data));
  } catch (error) {
    yield put(EvaluationSearchSupervisionReportError(error));
  }
}

function* onEvaluationAdd(data) {
  try {
      const response = yield call(onEvaluationAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationAddSuccess(response.data));
  } catch (error) {
      yield put(EvaluationAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEvaluationDetail(data) {
  try {
    const response = yield call(onEvaluationDetailAsync, data.payload);
    yield put(EvaluationDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EvaluationDetailError(error)); 
  }
}

function* onEvaluationGet(data) {
  try {
    const response = yield call(onEvaluationGetAsync, data.payload);
    yield put(EvaluationGetSuccess(response.data.data));
  } catch (error) {
    yield put(EvaluationGetError(error)); 
  }
}

function* onEvaluationUpdate(data) {
  try {
      const response = yield call(onEvaluationUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationUpdateSuccess(response.data));
  } catch (error) {
      yield put(EvaluationUpdateError(error));
  }
}

function* onEvaluationUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onEvaluationUploadAsync, file);
    if(response.message ==='success'){
      yield put(EvaluationUploadSetSuccess(response));
    }
    else{
      yield put(EvaluationUploadSetError(response));
    }
  } catch (error) {
    yield put(EvaluationUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEvaluationList),
    fork(watchEvaluationSearchAssessment),
    fork(watchEvaluationSearchAssessmentProject),
    fork(watchEvaluationSearchSupervisionReport),
    fork(watchEvaluationAdd),
    fork(watchEvaluationDetail),
    fork(watchEvaluationGet),
    fork(watchEvaluationUpdate),
    fork(watchEvaluationUpload),
  ]);
} 